import { useIntl } from 'react-intl';
import { getLoginRedirectUrl } from 'utils/edx-auth';
import { AlertModal } from '../../alert-modal';
import { messages } from './session-invalid-alert-modal.messages';
import { SessionInvalidAlertModalProps } from './types';

export const SessionInvalidAlertModal = ({
  isOpen,
}: SessionInvalidAlertModalProps) => {
  const { formatMessage } = useIntl();

  const redirectToLogin = () => window.location.replace(getLoginRedirectUrl());

  return (
    <AlertModal
      isOpen={isOpen}
      title={formatMessage(messages['checkout.session.invalid.alert.title'])}
      message={formatMessage(
        messages['checkout.session.invalid.alert.message'],
      )}
      buttonText={formatMessage(
        messages['checkout.session.invalid.alert.button'],
      )}
      onClickButton={redirectToLogin}
    />
  );
};
